import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatProgressBar } from '@angular/material/progress-bar';
import { TranslatePipe } from '@ngx-translate/core';
import { BatchRepairProgress, BatchRepairProgressService } from '../batch-repair-progress.service';

@Component({
  selector: 'app-batch-repair-progress-card',
  standalone: true,
  imports: [AsyncPipe, MatButton, MatCard, MatCardContent, MatIcon, MatProgressBar, TranslatePipe],
  templateUrl: './batch-repair-progress-card.component.html',
  styleUrls: ['./batch-repair-progress-card.component.scss'],
})
export class BatchRepairProgressCardComponent {
  constructor(readonly service: BatchRepairProgressService) {}

  percentage(p: BatchRepairProgress): number {
    if (p.total === 0) {
      return 0;
    }
    return Math.round((p.current / p.total) * 100);
  }
}
